import Vue from "vue";
import VueI18n from "vue-i18n";
import zh_cn from "./language/zh.json";
import en_us from "./language/en.json";

Vue.use(VueI18n); // 全局挂载

export const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || "zh_cn", // 从localStorage中获取 默认英文
  messages: {
    zh_cn,
    en_us
  }
});

export default i18n;